// extracted by mini-css-extract-plugin
module.exports = {"dashed-border":"1px dashed #979797","card":"Card_card__iUcDX","selectedCard":"Card_selectedCard__3Co9O","hovering":"Card_hovering__3p5dt"};